import { z } from "zod";
import { ICON_NAMES } from "./icon.generated.js";
export { ICON_NAMES };
export const IconNameSchema = z.enum(ICON_NAMES);
//# sourceMappingURL=icon.js.map